import { AITaskResponseResultData } from 'api/collaborateApi';
import { CollaborateTaskData } from 'types/api/collaborate';
import { PendingTask } from '../store/tasksSlice';

// Type for converted AI tasks that can be used in clustering and stickers
export interface ConvertedAiTask {
  task_comment_id: number;
  task_id: string;
  task_status: 'open';
  task_priority: 'medium';
  is_internal: false;
  task_element_path: string;
  aiTaskData: AITaskResponseResultData;
  isAiTask: true;
}

// Union type for all task types including AI tasks
export type TaskWithAi = CollaborateTaskData | PendingTask | ConvertedAiTask;

// Type guard to check if a task is an AI task
export const isAiTask = (task: TaskWithAi): task is ConvertedAiTask => {
  return 'isAiTask' in task && task.isAiTask === true;
};

// Type guard to check if a task is a regular collaborate task
export const isCollaborateTask = (task: TaskWithAi): task is CollaborateTaskData => {
  return 'task_type' in task && !isAiTask(task);
};

// Type guard to check if a task is a pending task
export const isPendingTask = (task: TaskWithAi): task is PendingTask => {
  return task.task_id.includes('PENDING') || task.task_id.includes('OPTIMISTIC');
}; 